import type * as Types from 'app/types/graphql';

export type ThemeSelectFragment = Pick<
  Types.Theme,
  'createdAt' | 'id' | 'isGlobal' | 'isPublished' | 'name' | 'thumbnail' | 'updatedAt'
>;

export const ThemeSelectFragmentDoc = `
    fragment ThemeSelect on Theme {
  createdAt
  id
  isGlobal
  isPublished
  name
  thumbnail
  updatedAt
}
    `;
